<template>
  <div>
    <div class="items__top">
      <div class="d-flex align-center flex-wrap py-2 mb-2">
          <v-spacer></v-spacer>
          <v-row dense :class="`d-flex mt-n${largeMargin ? 13 : 8}`" no-gutters>
            <template>
              <v-col cols="9" offset="3" class="d-flex justify-end" align-self="end">
                <v-btn class="general-table__btn general-table__btn--block" @click="showModal('newArticle')">
                  <v-icon left>mdi-plus</v-icon>
                  <lang t="ARTICLES-BTN-NEW_ARTICLE"></lang>
                </v-btn>

                <v-btn
                  :disabled="selectedBundles.length == 0"
                  class="general-table__btn general-table__btn--block"
                  @click="showModal('batchProcessing')"
                >
                  <v-icon left>mdi-content-duplicate</v-icon>
                  <lang t="ARTICLES-BTN-BATCH_PROCESSING"></lang>
                </v-btn>

                <v-btn
                  class="general-table__btn general-table__btn--block"
                  @click="showModal('confirmRecalculate')"
                >
                  <v-icon left>mdi-calculator-variant-outline</v-icon>
                  <lang t="ARTICLES-BTN-BATCH_RECALCULATE"></lang>
                </v-btn>

                <v-btn class="general-table__btn general-table__btn--block" @click="showModal('duplicates')">
                  <v-icon left>mdi-content-copy</v-icon>
                  <lang t="ARTICLES-BTN-DUPLICATES"></lang>
                </v-btn>

                <v-btn  :disabled="disableImportBtn" class="general-table__btn general-table__btn--block" @click="showModal('import')">
                  <v-icon left>mdi-database-import</v-icon>
                  <lang t="ARTICLES-BTN-IMPORT"></lang>
                </v-btn>
              </v-col>
            </template>
            <template v-if="currentUser.role != 'prdSysSup'">
              <v-col cols="9" offset="3" class="d-flex justify-end">
                <v-btn class="general-table__btn general-table__btn--block" @click="showModal('exportMenu')">
                  <v-icon left>mdi-database-export</v-icon>
                  <lang t="ARTICLES-BTN-EXPORT"></lang>
                </v-btn>

              </v-col>
            </template>
          </v-row>
        </div>

        <div class="d-flex align-center flex-wrap py-2 mb-2 main-top-margin">
          <v-text-field
            clearable
            background-color="#fff"
            class="general-table__search general-table__search--short"
            :value="search"
            @input="searchChanged"
            prepend-inner-icon="mdi-magnify"
            :label="$t('GLOBAL-DO_SEARCH')"
            
            solo
            flat
            dense
            filled
            hide-details
          />
        </div>

        <v-expansion-panels focusable flat multiple v-model="expansionPanel">
          <ExpensionPanelFilter :title="$t('FILTER')" :selectedPanels="expansionPanel">
            <v-row no-gutters dense class="pa-0">
              <v-col cols="2" class="d-flex align-stretch pa-0" v-for="filter in filters" :key="filter.name">
                <filter-item :filter="filter" @inactive="filter.isActive = false" @active="filter.isActive = true" @clearSelection="() => {filter.selection = ''; filter.isActive = false; }" @removeFilterItem="removeFilterItem(filter)"/>
              </v-col>
              <v-col>
                <v-menu
                  v-model="showFilterAddMenu"
                  :max-height="600"
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" small elevation="0" class="btn--uppercase mt-2"  :class="`${filtersHasCustomAttribute? 'ml-1': ''}`"
                        v-bind="attrs"
                        v-on="on">
                                  <v-icon small>mdi-plus</v-icon>
                                  <span>{{$t('FILTER-ADD')}}</span>
                                </v-btn>
                      
                    </template>
                    <v-card>
                      <v-list dense v-if="availableCustomItemAttributes && availableCustomItemAttributes.length > 0">
                        <v-list-group
                          :value="false"
                        >
                          <template v-slot:activator>
                            <v-list-item-title>{{ $t('FILTER-ARTICLE-ATTRIBUTES') }}</v-list-item-title>
                          </template>

                            <v-list-item  v-for="attr in availableCustomItemAttributes" :key="attr.id" class="clickable" @click="addCustomAttributeToFilter(attr)">
                              <v-list-item-title v-text="getAttributeName(attr)"  />
                            </v-list-item>
                      </v-list-group>
                      </v-list>
                      <v-divider></v-divider>
                      <v-list dense v-if="availableCustomBundleAttributes && availableCustomBundleAttributes.length > 0">
                        <v-list-group
                          :value="false"
                        >
                          <template v-slot:activator>
                            <v-list-item-title>{{ $t('FILTER-PACK-UNIT-ATTRIBUTES') }}</v-list-item-title>
                          </template>

                            <v-list-item  v-for="attr in availableCustomBundleAttributes" :key="attr.id" class="clickable" @click="addCustomAttributeToFilter(attr)">
                              <v-list-item-title v-text="getAttributeName(attr)"/>
                            </v-list-item>
                      </v-list-group>
                      </v-list>
                    </v-card>
                </v-menu>
                  
              </v-col>
            </v-row>
          </ExpensionPanelFilter>
        </v-expansion-panels>

        <v-row class="mb-n2 mt-6">
          <v-col cols="12">
            <filter-selector :filter="filter" v-for="filter in filters" :key="filter.name" @unselected="getDataFromApi"/>
            <template v-if="search.length >= 3">
              
            <filter-selector :filter="searchFilterItem" @unselected="clearSearchByFilterUnselect"/>
            </template>
          </v-col>
        </v-row>

    </div>

    <div class="items__loading-wrapper" v-if="isLoading">
          <v-progress-circular :size="38" :width="3" color="primary" indeterminate> </v-progress-circular>
    </div>
    <template v-else>      
      <ul class="items__list">
        <template v-if="!items.length">
            <li class="items__list--no-data"><span>{{ $t('GLOBAL-NO_DATA_FOUND') }}</span></li>
        </template>
        <template v-else>
          <li  v-for="(row, index) in items" :key="index">
            <ItemRow :item="row" @showKisoftTelegram="($id) => showModal('kisoftTelegram', $id)"/>
          </li>
          <li>
            <UIPagination :pagination="pagination" @updatePagination="updatePagination"/>
          </li>  
        </template>
        
      </ul>
  </template> 

    <v-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :max-width="dialog.maxSize + 'px'" :key="dialog.type" :persistent="false">
      <v-card>
        <v-card-title>
          <span :class="`title1`"><lang :t="dialog.title"></lang></span>

          <v-spacer></v-spacer>

          <v-btn icon light @click="closeModal(dialog.refreshOnClose)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- IMPORT -->
        <template v-if="dialog.type == 'import'">
          <article-importer
            :visible="dialog.show"
            @closeModal="closeModal(true)"
            @changeToFullScreen="dialog.fullscreen = true"
            :warehouseId="warehouseId"
          ></article-importer>
        </template>

        <!-- EXPORT MENU-->
        <template v-else-if="dialog.type === 'exportMenu'">
          <v-card-text>
            <div class="row">
              <div class="col-12">
                <span class="mb-2">{{ $t('PICK_EXPORT_GROUP') }}</span>
                <ul style="list-style: none;">
                  <li v-for="item in allExportGroups">
                    <checkbox hideDetails :isSimple="false" :value="item.selected" :label="item.label" @updatedValue="(val) => item.selected = val"/>
                  </li>
                </ul>
              </div>

              <div class="col-12 d-flex flex-column">
                <span class="mb-2">{{ $t('PICK_EXPORT_TYPE') }}</span>
                <v-btn-toggle v-model="exportType" >
              <v-btn value="exportAsHtml" style="flex: 1 1 25%; padding: .25em .5em;">
                <span>HTML</span>
              </v-btn>
              <v-btn value="exportAsXml" style="flex: 1 1 25%; padding: .25em .5em;" v-if="enableXMLExportOption">
                <span>XML (KiSoft)</span>
              </v-btn>
              <v-btn value="export" style="flex: 1 1 25%; padding: .25em .5em;">
                <span>XLS</span>
              </v-btn>
              <v-btn value="exportWithImages" style="flex: 1 1 25%; padding: .25em .5em;">
                <span>XLS {{ $t('with pictures') }}</span>
              </v-btn>
            </v-btn-toggle>
              </div>
             
            </div>
            
            
          </v-card-text>
        </template>
        <!-- EXPORT -->
        <template v-else-if="['export', 'exportAsHtml', 'exportAsXml'].includes(dialog.type)">
          <v-card-text>
            <div class="d-flex flex-column align-center justify-center" style="min-height: 80px;">
              <template v-if="downloadLink != null">
                <v-btn elevation="0" light rounded color="themeColor" @click="download()">
                  <v-icon left>mdi-download</v-icon>
                  <lang t="ARTICLES-EXPORT-BTN-DOWNLOAD_PDF"></lang>
                </v-btn>
              </template>

              <template v-else>
                <v-progress-linear
                  :value="currentExportStatus.progress * 100"
                  style="max-width: 640px;"
                  color="themeColor"
                  readonly
                  rounded
                  height="26"
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>

                <div class="mt-1" style="font-size: 11px;">
                  Index: {{ currentExportStatus.index }} | Total:
                  {{ currentExportStatus.total }}
                </div>

                <div class="mt-1 text-center error--text" v-if="currentExportStatus.errorMsg">
                  {{ currentExportStatus.errorMsg }}
                </div>
              </template>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="closeModal()" :disabled="isSaving">
              <template v-if="downloadLink == null"><lang t="GLOBAL-BTN-CANCEL"></lang></template>
              <template v-else><lang t="GLOBAL-BTN-CLOSE"></lang></template>
            </v-btn>
          </v-card-actions>
        </template>

        <!-- NEW ARTICLE -->
        <template v-else-if="dialog.type == 'newArticle'">
          <v-card-text>
            <v-form ref="newArticleForm" v-model="newArticleFormStatus" lazy-validation>
              <v-select
                v-if="warehouseId == null"
                :items="warehouses"
                item-text="name"
                item-value="id"
                value="id"
                v-model="editedItem.warehouse_id"
                :label="$t('SELECT-BOX-PLEASE_SELECT_WAREHOUSE')"
              >
              </v-select>

              <v-text-field v-model="editedItem.name" :label="$t('ARTICLE-NAME')" required :rules="[rules.required]"></v-text-field>
              <v-text-field v-model="editedItem.articleNo" :label="$t('ARTICLE-ARTICLE_NO')" required :rules="[rules.required]"></v-text-field>
              <v-textarea
                v-model="editedItem.shortDescription"
                :label="$t('ARTICLE-SHORT_DESCRIPTION')"
                required
                :rules="[rules.required]"
                rows="2"
              ></v-textarea>
              <v-textarea
                v-model="editedItem.description"
                :label="$t('ARTICLE-DESCRIPTION')"
                required
                :rules="[rules.required]"
                rows="4"
              ></v-textarea>

              <v-divider class="my-3" style="border: none;"></v-divider>

              <!-- CASE -->
              <v-subheader class="pa-0"><lang t="ARTICLE-ADD_ARTICLE-CASE"></lang></v-subheader>

              <v-row dense>
                <v-col>
                  <v-text-field v-model="editedItem.bundles.case.name" :label="$t('ARTICLE-BUNDLE-NAME')" single-line dense required></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="editedItem.bundles.case.gtin" :label="$t('ARTICLE-BUNDLE-GTIN')" single-line dense required></v-text-field>
                </v-col>
              </v-row>

              <!-- PACK -->
              <v-subheader class="pa-0"><lang t="ARTICLE-ADD_ARTICLE-PACK"></lang></v-subheader>

              <v-row dense>
                <v-col>
                  <v-text-field v-model="editedItem.bundles.pack.name" :label="$t('ARTICLE-BUNDLE-NAME')" single-line dense></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="editedItem.bundles.pack.gtin" :label="$t('ARTICLE-BUNDLE-GTIN')" single-line dense></v-text-field>
                </v-col>
              </v-row>

              <!-- UNIT -->
              <v-subheader class="pa-0"><lang t="ARTICLE-ADD_ARTICLE-UNIT"></lang></v-subheader>

              <v-row dense>
                <v-col>
                  <v-text-field v-model="editedItem.bundles.unit.name" :label="$t('ARTICLE-BUNDLE-NAME')" single-line dense></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field v-model="editedItem.bundles.unit.gtin" :label="$t('ARTICLE-BUNDLE-GTIN')" single-line dense></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal()" :disabled="isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" :disabled="!newArticleFormStatus" class="general-action-btn" @click="newArticle()" :loading="isSaving"><lang t="GLOBAL-BTN-SAVE"></lang></v-btn>
          </v-card-actions>
        </template>

        <!-- BATCH PROCESSING -->
        <template v-else-if="dialog.type == 'batchProcessing'">
          <v-card-text>
            <v-form ref="form3">
              <v-row dense>
                <template v-if="caseSelectedBundles.length > 0">
                  <v-col cols="12" sm="12">
                  <span>{{ $t('ARTICLE-CASE-ASSIGN-LABEL', { amount: caseSelectedBundles.length }) }}</span>
                  <v-select
                    :items="caseBundleGroups"
                    :label="$t('SELECT-BOX-BUNDLE_GROUPS')"
                    v-model="pickedCaseBundleGroups"
                    item-text="name"
                    item-value="id"
                    :return-object="true"
                  >
                  </v-select>
                </v-col>
                </template>

                <template v-if="packSelectedBundles.length > 0">
                  <v-col cols="12" sm="12">
                  <span>{{ $t('ARTICLE-PACK-ASSIGN-LABEL', { amount: packSelectedBundles.length }) }}</span>
                  <v-select
                    :items="packBundleGroups"
                    :label="$t('SELECT-BOX-BUNDLE_GROUPS')"
                    v-model="pickedPackBundleGroups"
                    item-text="name"
                    item-value="id"
                    :return-object="true"
                  >
                  </v-select>
                </v-col>
                </template>
                
                <template v-if="unitSelectedBundles.length > 0">
                  <v-col cols="12" sm="12">
                  <span>{{ $t('ARTICLE-UNIT-ASSIGN-LABEL', { amount: unitSelectedBundles.length }) }}</span>
                  <v-select
                    :items="unitBundleGroups"
                    :label="$t('SELECT-BOX-BUNDLE_GROUPS')"
                    v-model="pickedUnitBundleGroups"
                    item-text="name"
                    item-value="id"
                    :return-object="true"
                  >
                  </v-select>
                </v-col>
                </template>
                
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal()" :disabled="isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" :disabled="!enableBatchProcessingAssignBtn" light rounded color="themeColor" @click="mainBatchConfirmation()" :loading="isSaving"
              ><lang t="BTN-ASSIGN"></lang
            ></v-btn>
          </v-card-actions>
        </template>

        <!-- PRE-CONFIRM RECALCULATE -->
        <template v-else-if="dialog.type == 'confirmRecalculate'">
          <v-card-text class="pb-10 text-center" style="font-size: 16px;">
            {{
              $t("CONFIRM_BATCH_RECALCULATE_MESASGE", {
                COUNT: itemsTotal,
              })
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal()" :disabled="isSaving"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="recalculate()" :loading="isSaving"
              ><lang t="GLOBAL-BTN-RECALCULATE"></lang
            ></v-btn>
          </v-card-actions>
        </template>

        <!-- BATCH RECALCULATE -->
        <template v-else-if="dialog.type == 'batchRecalculate'">
          <v-card-text class="pb-10 text-center">
            
              <!--v-progress-circular v-if="isSaving" key="1" :size="90" color="primary" indeterminate> </!--v-progress-circular-->

              <div v-if="currentRecalculateStatus.progress >= 1" >
                <v-icon color="green" :size="80">mdi-check-circle</v-icon>
                <div><lang t="BUNDLE-RECALCULATION_FINISHED" /></div>
              </div>
              <template v-else>
                <v-progress-linear
                  :value="currentRecalculateStatus.progress * 100"
                  style="max-width: 640px;"
                  color="themeColor"
                  readonly
                  rounded
                  height="26"
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>

                <div class="mt-1" style="font-size: 11px;">
                  <template v-if="!currentRecalculateStatus.message">Index: {{ currentRecalculateStatus.index }} | Total:
                  {{ currentRecalculateStatus.total }}</template>
                  <template v-else>
                    {{ currentRecalculateStatus.message }}
                  </template>
                </div>

                <div class="mt-1 text-center error--text" v-if="currentRecalculateStatus.errorMsg">
                  {{ currentRecalculateStatus.errorMsg }}
                </div>
              </template>

            
          </v-card-text>

        </template>

        <!-- DUPLICATES -->
        <template v-else-if="dialog.type == 'duplicates'">
          <v-card-text class="pb-10 text-center">
            <v-progress-circular v-if="duplicatesLoading" key="1" :size="50" color="primary" indeterminate> </v-progress-circular>

            <template v-else>
              <v-simple-table dense v-if="duplicates.duplicates.length > 0">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" scope="col">Name</th>
                      <th class="text-left" scope="col">Bundles</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in duplicates.duplicates" :key="item.name">
                      <td class="text-left">{{ item.name }}</td>
                      <td class="text-left">{{ item.bundles.length }}</td>
                      <td class="text-left">
                        <v-btn
                          elevation="0"
                          small
                          light
                          rounded
                          color="themeColor"
                          class="btnTheme"
                          @click="showModal('resolveDuplicates', item.name)"
                        >
                          <v-icon left>mdi-autorenew</v-icon>
                          <lang t="ARTICLES-BTN-DUPLICATES_RESOLVE"></lang>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <p v-else>{{$t('NO-DUPLICATES-TEXT')}}</p>
            </template>
          </v-card-text>
        </template>

        <!-- RESOLVE DUPLICATES -->
        <template v-else-if="dialog.type == 'resolveDuplicates' && duplicateSelected != null">
          <v-card-text>
            <v-simple-table dense v-if="getBundleAttributes(duplicateSelected.bundles).length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th scope="col">Attribut</th>
                    <th class="text-left" v-for="(bundle, index) in duplicateSelected.bundles" scope="col">
                      {{ "Bundle " + (index + 1) }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="attribute in getBundleAttributes(duplicateSelected.bundles)">
                    <td>{{ attribute }}</td>

                    <td v-for="(bundle, bundleIndex) in duplicateSelected.bundles.length">
                      <v-btn
                        block
                        elevation="0"
                        :color="attributesSelection[attribute] == duplicateSelected.bundles[bundleIndex].id ? 'themeColor' : ''"
                        small
                        @click="selectDefaultAttribute(attribute, duplicateSelected.bundles[bundleIndex].id)"
                        :key="attribute + bundle"
                      >
                        {{ duplicateSelected.bundles[bundleIndex].attributes[attribute] }}
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>

            </v-simple-table>

            <template v-else>
              <v-alert type="info" text dense>
                <lang t="NO-ATTRIBUTES-DUPLICATES-FOUND" />
              </v-alert>
            </template>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showModal('duplicates')" :disabled="isSaving"><lang t="GLOBAL-BTN-BACK"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="mergeDuplicates(duplicateSelected.bundles)" :loading="isSaving"
              ><lang t="GLOBAL-BTN-MERGE"></lang
            ></v-btn>
          </v-card-actions>
        </template>

        <!-- BATCH BUNDLE ASSIGN ERRORS -->
        <template v-else-if="dialog.type == 'checkBatchAssignBundles'">
          <v-card-text>

            <div class="mb-5 ml-auto text-right text-subtitle-1">
              <lang t="ARTICLES-BATCH_PROCESSING-USED_TOLERANCE" />
              {{ checkBatchAssignBundlesErrors.bundlegroup.tolerance * 100 }}%
            </div>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" v-for="colName in checkBatchAssignBundlesErrors._cols" scope="col">
                      {{ colName }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td v-for="colName in checkBatchAssignBundlesErrors._cols">
                      <strong>{{ checkBatchAssignBundlesErrors.bundlegroup[colName] }}</strong>
                    </td>
                  </tr>

                  <tr v-for="err in checkBatchAssignBundlesErrors.errors">
                    <td v-for="colName in checkBatchAssignBundlesErrors._cols">
                      <template v-if="colName == 'name'">
                        {{ err.bundle.name }}
                      </template>

                      <template v-else>
                        <template v-if="err.errors[colName]">
                          {{ (err.errors[colName].diff * 100).toFixed(2) }}% ({{ err.errors[colName].bundle }})
                        </template>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <br /><br /><br />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :disabled="isSaving" @click="closeModal()"><lang t="GLOBAL-BTN-CANCEL"></lang></v-btn>
            <v-btn elevation="0" light rounded color="themeColor" @click="batchIt()" :loading="isSaving"
              ><lang t="GLOBAL-BTN-START_BATCH"></lang
            ></v-btn>
          </v-card-actions>
        </template>

        <!-- kisoft Telegram -->
        <template v-if="dialog.type == 'kisoftTelegram'">
          <v-card-text>
            <div v-if="kisoftTelegram.isLoading" class="text-center ma-12">
              <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
            </div>

            <template v-else>
              <!-- show data -->
              <div v-if="kisoftTelegram.data != null" style="overflow-x: auto;">
                <pre v-if="kisoftTelegram.data.telegram !== 'error'">{{ formatXml(kisoftTelegram.data) }}</pre>
                <v-alert v-else outlined type="error" elevation="0">
                  <lang t="ARTICLES-KISOFT-TELEGRAM-ERROR"></lang>
                </v-alert>
              </div>

              <!-- no data available -->
              <div v-else>
                <v-alert outlined type="warning" elevation="0">
                  <lang t="ARTICLES-KISOFT-TELEGRAM-NO_DATA"></lang>
                </v-alert>
              </div>
            </template>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import articleImporter from "./incl-articleImporter";
import FilterItem from "@/components/FilterItem.vue";
import FilterSelector from "@/components/FilterSelector.vue";
import ExpensionPanelFilter from "@/components/panels/ExpensionPanelFilter.vue";
import DisplayNumber from "../../components/DisplayNumber.vue";
import moment from 'moment'
import { converterMixin } from "../../mixins/converterMixin";
import {cloneDeep, isEqual} from 'lodash';
import SimpleChip from "../../components/ui-elements/SimpleChip.vue";
import ItemRow from './ItemRow.vue';
import UIPagination from "../../components/ui-elements/UIPagination.vue";
import Checkbox from "../../components/ui-elements/Checkbox.vue";

export default {
  name: "ItemIndex",
  mixins:[converterMixin],
  props: {
    warehouseId: {
      type: Number,
      default: null,
    },
    warehouse: {
      type: Object,
      default: () => ({}),
    },
    largeMargin: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    Checkbox,
    articleImporter,
    ExpensionPanelFilter,
    FilterItem,
    FilterSelector,
    DisplayNumber,
    SimpleChip,
    ItemRow,
    UIPagination
  },

  data() {
    return {
      dialog: {
        show: false,
        fullscreen: false,
        title: "",
        type: "",
        refreshOnClose: true
      },
      pagination:{
        itemsPerPage: 15, 
        page: 1,
        total: 0,
      },
      allExportGroups: [],
      newArticleForm: null,
      newArticleFormStatus: false,
      disableImportBtn: false,
      batchConfirmationPayload: null,
      bundleCustomAttributes: [],
      itemCustomAttributes: [],
      showFilterAddMenu: false,
      exportType: undefined,
      exportIncludeImages: undefined, 
      expansionPanel: [0],
      timeoutID: null,
      isSaving: false,
      isLoading: false,
      downloadLink: null,
      enableXMLExportOption: false,

      refreshIntervalId: null,
      currentExportStatus: null,
      currentRecalculateStatus: null,

      bundleGroups: null,

      kisoftTelegram: {
        data: null,
        isLoading: false,
      },

      editedItem: {
        name: "",
        shortDescription: "",
        description: "",
        bundlegroup_id: "",
        width: "",
        length: "",
        weight: "",
        height: "",
        warehouse_id: "",
        bundles: {
          case: {
            name: null,
            gtin: null,
          },
          pack: {
            name: null,
            gtin: null,
          },
          unit: {
            name: null,
            gtin: null,
          },
        },
      },

      defaultItem: {
        name: "",
        shortDescription: "",
        description: "",
        bundlegroup_id: "",
        width: "",
        length: "",
        weight: "",
        height: "",
        warehouse_id: "",
        bundles: {
          case: {
            name: null,
            gtin: null,
          },
          pack: {
            name: null,
            gtin: null,
          },
          unit: {
            name: null,
            gtin: null,
          },
        },
      },

      items: [],
      itemsTotal: 0,

      activeFilters: null,
      search: "",

      warehouses: null,
      searchFieldBGColor: "#FFF",
      oldFilters: [],
      filters: [
        {
          name: "isComplete",
          type: "default",
          isMultiple: false,
          isActive: false,

          options: [
            {
              id: 1,
              displayName: this.$t("FILTER-BY-COMPLETE"),
              internalValue: true,
              isSelected: false,
            },
            {
              id: 2,
              displayName: this.$t("FILTER-BY-INCOMPLETE"),
              internalValue: false,
              isSelected: false,
            },
          ],
        },

        {
          name: "bundlegroupId",
          type: "dropdownSingle",
          label: this.$t("FILTER-BY-BUNDLE"),
          isActive: false,
          api: "/bundlegroups",
          options: [],
          selection: [],
        },

        // ADP Program
        {
          name: "adpPrograms",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-ADP_PROGRAM"),
          isActive: false,
          api: "/bundles/filterSettings",
          apiKey: "adpPrograms",
          options: [],
          selection: [],
        },

        // Bundletype (Case)
        {
          name: "caseBundletypes",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-CASE_BUNDLETYPES"),
          isActive: false,
          api: "/bundles/filterSettings",
          apiKey: "caseBundletypes",
          options: [],
          selection: [],
        },

        // Bundletype (Unit)
        {
          name: "unitBundletypes",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-UNIT_BUNDLETYPES"),
          isActive: false,
          api: "/bundles/filterSettings",
          apiKey: "unitBundletypes",
          options: [],
          selection: [],
        },

        // Productionline
        {
          name: "productionline",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-PRODUCTION_LINES"),
          isActive: false,
          api: "/bundles/filterSettings",
          apiKey: "productionlines",
          // filterValue: 'value',
          options: [],
          selection: [],
        },

        // length
        {
          name: "length",
          type: "minMax",
          label: this.$t("FILTER-BY-LENGTH"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // width
        {
          name: "width",
          type: "minMax",
          label: this.$t("FILTER-BY-WIDTH"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // height
        {
          name: "height",
          type: "minMax",
          label: this.$t("FILTER-BY-HEIGHT"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // Area Pressure
        {
          name: "areaPressure",
          type: "minMax",
          label: this.$t("FILTER-BY-AREA_PRESSURE"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // Overhang Percentage
        {
          name: "overhangPercentage",
          type: "minMax",
          label: this.$t("FILTER-BY-OVERHANG_PERCENTAGE"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // Bridge Percentage
        {
          name: "bridgePercentage",
          type: "minMax",
          label: this.$t("FILTER-BY-BRIDGE_PERCENTAGE"),
          isActive: false,
          options: ["min", "max"],
          selection: { min: null, max: null },
        },

        // Palette
        {
          name: "palette",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-PALETTE"),
          isActive: false,
          api: "/loadcarriers",
          filterAfterFetch: (item) => item.type == "pallet",
          additionalFilterOption: {
            name: this.$t("FILTER-OPTION-NO-PALETT"),
            id: "no-inner",
          },
          options: [],
          selection: [],
        },

        // Slipsheets
        {
          name: "slipsheets",
          type: "slipsheet",
          label: this.$t("FILTER-BY-SLIPSHEET"),
          isActive: false,
          options: [],
          options1: [
            {
              label: this.$t("FILTER-OPTION-SLIPSHEETS-TOP"),
              value: "TOP",
            },
            {
              label: this.$t("FILTER-OPTION-SLIPSHEETS-BOTTOM"),
              value: "BOTTOM",
            },
          ],
          options2: [
            {
              label: this.$t("FILTER-OPTION-SLIPSHEETS-NO_INNER"),
              value: "NO_INNER",
            },
            {
              label: this.$t("FILTER-OPTION-SLIPSHEETS-SOME_INNER"),
              value: "SOME_INNER",
            },
            {
              label: this.$t("FILTER-OPTION-SLIPSHEETS-ALL_INNER"),
              value: "ALL_INNER",
            },
          ],
          selection: [],
        },

        // Gaps
        {
          name: "gaps",
          type: "dropdownMultiple",
          label: this.$t("FILTER-BY-GAP"),
          isActive: false,
          options: [
            {
              name: this.$t("FILTER-OPTION-GAPS-NONE"),
              id: "NONE",
            },
            {
              name: this.$t("FILTER-OPTION-GAPS-EDGE"),
              id: "EDGE",
            },
            {
              name: this.$t("FILTER-OPTION-GAPS-INSIDE"),
              id: "INSIDE",
            },
          ],
          selection: [],
        },

        {
          name: "changedManually",
          label: this.$t("FILTER-BY-CHANGED"),
          type: "default",
          isMultiple: false,
          isActive: false,
          options: [
            {
              id: 1,
              displayName: this.$t("FILTER-BY-CHANGED-MANUALLY"),
              internalValue: true,
              isSelected: false,
            },
            {
              id: 2,
              displayName: this.$t("FILTER-BY-CHANGED-AUTOMATICALLY"),
              internalValue: false,
              isSelected: false,
            },
          ],
        },

        {
          name: "created_at",
          type: "dateRange",
          isActive: false,
          selection: null,
        },
        {
          name: "lastEdit",
          type: "dateRange",
          isActive: false,
          selection: null,
        },
      ],

      duplicates: null,
      duplicatesLoading: false,
      duplicateSelected: null,
      attributesSelection: {},

      searchFilterItem:{
          name: "search",
          type: "search",
          label: this.$t("FILTER-BY-SEARCH"),
          isActive: true,
          options:[
            {
              id: 1,
              displayName: "",
            },
          ],
          selection: 1,
        },
      checkBatchAssignBundlesErrors: null,
      caseBundleGroups: [],
      unitBundleGroups: [],
      packBundleGroups: [],
      pickedCaseBundleGroups: null,
      pickedUnitBundleGroups: null,
      pickedPackBundleGroups: null,
      bundleLevelForBatchIt: [],
    };

  },

  computed: {
    currentUser() {
            return this.$store.getters.currentUser;
    },
    batchListPayloads(){
      return this.$store.getters['batchList'];
    },
    enableBatchProcessingAssignBtn(){
      let count = 0;
      if(this.caseSelectedBundles.length > 0 && this.pickedCaseBundleGroups  && this.pickedCaseBundleGroups.id > 0){
        count++;
      }
      if(this.unitSelectedBundles.length > 0 && this.pickedUnitBundleGroups && this.pickedUnitBundleGroups.id > 0){
        count++;
      }

      if(this.packSelectedBundles.length > 0 && this.pickedPackBundleGroups && this.pickedPackBundleGroups.id > 0){
        count++;
      }
      return count > 0;
      
    },
    selectedBundles(){
      return this.$store.getters['selectedBundles'];
    },
    caseSelectedBundles(){
      if(!this.selectedBundles || !this.selectedBundles.length) return [];
      return this.selectedBundles.filter((bundle) => bundle.level === 'case');
    },
    unitSelectedBundles(){
      if(!this.selectedBundles || !this.selectedBundles.length) return [];
      return this.selectedBundles.filter((bundle) => bundle.level === 'unit');
    },
    packSelectedBundles(){
      if(!this.selectedBundles || !this.selectedBundles.length) return [];
      return this.selectedBundles.filter((bundle) => bundle.level === 'pack');
    },
    filtersHasCustomAttribute() {
      return this.filters.some((el) => el.isCustomAttribute);
    },
    getAttributeName(){
      return (attribute) => {
        if(attribute.displayName && attribute.displayName[this.$store.getters.langShortcode]) return attribute.displayName[this.$store.getters.langShortcode];
        return this.$t('ARTICLE-BUNDLE-ATTRIBUTE-'+attribute.name.toUpperCase());
      }
    },
    availableCustomBundleAttributes(){
      return this.bundleCustomAttributes.filter((el) => !this.filters.some((filter) => filter.name === el.id)).sort((a, b) => {
        if(this.getAttributeName(a) > this.getAttributeName(b)) return 1;
        if(this.getAttributeName(a) < this.getAttributeName(b))return -1;
        return 0;
      });
    },
    availableCustomItemAttributes(){
      return this.itemCustomAttributes.filter((el) => !this.filters.some((filter) => filter.name === el.id)).sort((a, b) => {
        if(this.getAttributeName(a) > this.getAttributeName(b)) return 1;
        if(this.getAttributeName(a) < this.getAttributeName(b))return -1;
        return 0;
      });;
    },
    startExport(){
      return this.exportType !== undefined;
    },
    params(nv, old) {
      return {
        itemsPerPage: this.pagination.itemsPerPage,
        page: this.pagination.page,
        query: this.search,
        warehouseId: this.warehouseId,
      };
    },
  },

  watch: {
    "dialog.show"(val) {
      val || this.closeModal();
    },
    startExport(status){
      if(!status) return;
      this.dialog.show = false;
      this.showModal(this.exportType);
    },
    batchListPayloads:{
      async handler(list){
        if(!list || !list.length){
          this.$store.commit('RESET_SELECTED_BUNDLES'); 
          return;
        }
        const payload = cloneDeep(list).shift();
        await this.batchConfirmationByPayload(payload);
      },
      deep: true
    },
    params: {
      handler(val, oldVal) {
        const time = !oldVal || (oldVal && val.query !== oldVal.query)? 1000: 200;
        clearTimeout(this.timeoutID);
        this.$store.state.articles.params = val;
        this.timeoutID = setTimeout(() => {
          this.getDataFromApi();
        }, time);
      },
      deep: true,
      immediate: true
    },
    bundleGroups: {
      handler(list){
        this.prepareBundleGroupLists(list);
      },
      deep: true,
      immediate: true
    },

    search(newVal, oldVal) {
      if(newVal.length <= 2) return;
      this.$store.state.articles.search = newVal;
    },

    filters: {
      handler(val, oldVal) {

        const hasChanged = val.some((el) => {
          if(!el || !el.selection) return false;
          const selection = el.selection;
          const oldElement = this.oldFilters.find(oldEl => oldEl.name === el.name);
          if(!oldElement) return false;
          return !isEqual(selection, oldElement.selection);
        });
        this.oldFilters = cloneDeep(this.filters);
        if(!hasChanged) return;
        clearTimeout(this.timeoutID);
        this.$store.state.articles.filters = val;
        this.pagination.page =1;
        this.timeoutID = setTimeout(() => {
          this.getDataFromApi();
        }, 750);
      },
      deep: true,
    },
  },

  async created() {
    // in case this component is embedded
    if(this.warehouseId === null && this.currentUser && (this.currentUser.role == "su" || !this.currentUser.warehouse_id)){
      this.disableImportBtn = true;
    }else{
      this.disableImportBtn = false;
    }
    
    if (this.warehouseId != null) {
      this.searchFieldBGColor = "#F5F5F5"; // change background color of search field in case it is embedded and not readable well
      this.editedItem.warehouse_id = this.warehouseId;
      this.defaultItem.warehouse_id = this.warehouseId;
    }

    if (this.$store.state.articles) {
      let storeItems = this.$store.state.articles;
      if (storeItems.params) {
        this.pagination = Object.assign(this.pagination, storeItems.params);
      }
      if (storeItems.filters) {
        this.filters = storeItems.filters;
      }
      if (storeItems.search) {
        this.search = storeItems.search;
      }
    }

    // if there was a query param "incomplete", active the filter
    if (this.$route.query?.incomplete) {
      let completeFilter = this.filters.find((filter) => filter.name == "isComplete");
      completeFilter.isActive = true;
      let o = completeFilter.options.find((o) => o.displayName == this.$t("FILTER-BY-INCOMPLETE"));
      o.isSelected = true;
    }

    if (this.warehouseId && this.warehouse && this.warehouse.loadcarriers) {
      let paletteFilter = this.filters.find((filter) => filter.name == "palette");

      paletteFilter.api = null;
      paletteFilter.options = this.warehouse.loadcarriers;
      paletteFilter.options.push({
        name: this.$t("FILTER-OPTION-NO-PALETT"),
        id: "no-inner",
      });
    }

    if (this.currentUser.role == "su" || this.currentUser.role == "prdSysSup") {
      if (this.filters.find((f) => f.name == "depalReadiness") == undefined) {
        this.filters.push(
          // ProductionSystem Readiness
          {
            name: "depalReadiness",
            type: "dropdownMultiple",
            label: this.$t("FILTER-BY-PRDS-READINESS"),
            isActive: false,
            options: [
              { name: this.$t("FILTER-OPTION-DEPALREADINESS-YES"), id: "YES" },
              { name: this.$t("FILTER-OPTION-DEPALREADINESS-NO"), id: "NO" },
              {
                name: this.$t("FILTER-OPTION-DEPALREADINESS-CONDITIONAL"),
                id: "CONDITIONAL",
              },
              {
                name: this.$t("FILTER-OPTION-DEPALREADINESS-INCOMPLETE"),
                id: "INCOMPLETE",
              },
            ],
            selection: [],
          }
        );
      }
    }
    await this.getWarehouses();
    this.initAttributes();
    this.oldFilters = cloneDeep(this.filters);
    const bundleGroupsResponse = await this.axios.get(this.$config.api + "/bundlegroups");
    this.bundleGroups = bundleGroupsResponse.data;
  },

  mounted() {},

  methods: {
    removeFromBatchListPayload(payload){
      if(!this.batchListPayloads || !this.batchListPayloads.length || !payload || !payload.id) return true;
      const list = cloneDeep(this.batchListPayloads).filter((el) => el.id !== payload.id);
      this.$store.commit('SET_BATCH_LIST', list);
    },
    prepareBundleGroupLists(bundleGroups){
      const defaultBundleGroups = {id: 0, name: this.$i18n.t('BUNDLE-GROUPS-NOT-USE')};
      if(!bundleGroups || !bundleGroups.length){
        this.caseBundleGroups = [defaultBundleGroups];
        this.packBundleGroups = [defaultBundleGroups];
        this.unitBundleGroups = [defaultBundleGroups];
        return;
      }
      let caseBundleGroups = cloneDeep(bundleGroups).filter((el) => el.level === 'case');
      let unitBundleGroups = cloneDeep(bundleGroups).filter((el) => el.level === 'unit');
      let packBundleGroups = cloneDeep(bundleGroups).filter((el) => el.level === 'pack');
      this.caseBundleGroups = [defaultBundleGroups, ...cloneDeep(caseBundleGroups)];
      this.unitBundleGroups = [defaultBundleGroups, ...cloneDeep(unitBundleGroups)];
      this.packBundleGroups = [defaultBundleGroups, ...cloneDeep(packBundleGroups)];
    },
    updatePagination(data){
      this.pagination = cloneDeep(data);
    },
    clearSearchByFilterUnselect(){
      this.search = '';
    },
    removeFilterItem(filterItem){
      this.filters = this.filters.filter((el) => el.name !== filterItem.name);
      this.getDataFromApi();
    },

    searchChanged(text){
      let search = '';

      if(text.length > 2) {
        search = text;
      }

      if(this.search === search) return;
      this.searchFilterItem.options[0].displayName = search;
      this.searchFilterItem.isActive = true;
      this.search = search;
      this.pagination.page = 1;
    },

    addCustomAttributeToFilter(attribute){
      let type = '';
      let options, selection, itemText, itemValue;
      switch(attribute.type){
        case "number":
        case "integer": {
          type = "minMax";
          options = ["min", "max"];
          selection = { min: null, max: null };
          break;
        }
        case "boolean": {
          type = 'dropdownSingle';
          itemText = 'label';
          itemValue = 'value';
          options = [
            {value: '1', label: this.$t('GLOBAL_TRUE')},
            {value: '0', label: this.$t('GLOBAL_FALSE')},
          ]
          selection = null;
          break;
        }
        case "enum":{
          type = 'dropdownMultiple';
          itemText = 'label';
          itemValue = 'value';
          if(!attribute.settings || !attribute.settings.options){
            options = [];
          }else{
            options = attribute.settings.options.map((el) => {
              return  {value: el, label: el};
            })
          }
          selection = [];
          break;
        }
        case "date":{
          type = 'dateRange';
          selection=null;
          break;
        }
        case "string":{
          type = 'textbox';
          selection = null;
          break;
        }
        default:
          throw new Error(`Unsupported type ${attribute.type}`);
      }
      const filterItem = {
        name: attribute.id,
        isActive: false,
        label: this.getAttributeName(attribute), 
        type,
        options,
        selection,
        itemText,
        itemValue,
        isCustomAttribute: true,
      }
      const filters = cloneDeep(this.filters);
      filters.push(filterItem);
      this.filters = cloneDeep(filters);
      this.showFilterAddMenu = false;
    },
    fetchDuplicates() {
      let duplicateURL = "/bundles/duplicates" + (this.warehouseId != null ? "?warehouse_id=" + this.warehouseId : "");
      return this.axios.get(duplicateURL);
    },


    fetchExportGroups(){
      return this.axios.get('/items/exportGroups');
    },

    selectDefaultAttribute(attribute, bundleId) {
      this.$set(this.attributesSelection, attribute, bundleId);
    },

    getBundleAttributes(bundles) {
      let attributes = [];

      bundles.forEach((bundle) => {
        Object.entries(bundle.attributes).forEach((entry) => {
          const [key, value] = entry;

          if (value && attributes.indexOf(key) == -1) {
            attributes.push(key);
          }
        });
      });

      return attributes;
    },

    mergeDuplicates(bundles) {
      this.isSaving = true;

      let payload = {
        bundle_ids: bundles.map((b) => b.id),
        mapping: {
          ...this.attributesSelection,
        },
      };

      this.axios
        .post("/bundles/merge", payload)
        .then((res) => {
          if (res.data.error) {
            this.$store.dispatch("setSnackbar", {
              text: res.data.error,
              type: "error",
            });
          } else {
            this.fetchDuplicates().then((res) => {
              this.duplicates = res.data;
              this.showModal("duplicates");
            });
          }
        })
        .catch((err) => {
          console.error("error: ", err);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    async mainBatchConfirmation(){
      const payloads = [];
          if(this.caseSelectedBundles.length > 0 && this.pickedCaseBundleGroups && this.pickedCaseBundleGroups.id > 0){
            payloads.push({
              bundle_ids: this.caseSelectedBundles.map((i) => i.id),
              level: 'case',
              id: this.pickedCaseBundleGroups.id,
              name: this.pickedCaseBundleGroups.name

            });
          }

          if(this.unitSelectedBundles.length > 0 && this.pickedUnitBundleGroups && this.pickedUnitBundleGroups.id > 0){
            payloads.push({
              bundle_ids: this.unitSelectedBundles.map((i) => i.id),
              level: 'unit',
              id: this.pickedUnitBundleGroups.id,
              name: this.pickedUnitBundleGroups.name
            });
          }

          if(this.packSelectedBundles.length > 0 && this.pickedPackBundleGroups && this.pickedPackBundleGroups.id > 0){
            payloads.push({
              bundle_ids: this.packSelectedBundles.map((i) => i.id),
              level: 'pack',
              id: this.pickedPackBundleGroups.id,
              name: this.pickedPackBundleGroups.name
            });
          }
          
          if(!payloads.length) return;
          this.$store.commit('SET_BATCH_LIST', cloneDeep(payloads));
          
    },

    async batchConfirmationByPayload(payload) {
      await this.$confirm(
        this.$t("CONFIRM_BATCH_ASSIGN_ITEM_GROUP_MESSAGE", {
          COUNT: payload.bundle_ids.length,
          ITEM_GROUP_NAME: payload.name,
        }),
        {
          title: this.$t("GLOBAL-CONFIRMATION-BATCH_ASSIGN-TITLE"),
          buttonTrueText: this.$t("GLOBAL-BTN-YES"),
          buttonFalseText: this.$t("GLOBAL-BTN-CANCEL"),
        }
      ).then(async (res) => {
        if (res == true) {
          this.isSaving = true;
          try{
            this.bundleLevelForBatchIt.push(payload.level);
            const response = await this.axios
            .post("bundlegroups/" + payload.id + "/checkBatchAssignBundles", {bundle_ids: payload.bundle_ids});
            if (response.data && response.data.length == 0) {
                await this.batchIt();
                this.removeFromBatchListPayload(cloneDeep(payload));
              }
              else {
                //errors
                this.checkBatchAssignBundlesErrors = response.data;
                this.batchConfirmationPayload = cloneDeep(payload);
                this.checkBatchAssignBundlesErrors._cols = Object.keys(response.data.bundlegroup).filter((k) => k != "tolerance");
                this.showModal("checkBatchAssignBundles");
              }
          }catch(err){
            console.error(err);
          }finally{
            this.isSaving = false;
          }
          
        }
      });
    },

    async batchIt() {
      this.isSaving = true;
      let list = [];
      if(this.bundleLevelForBatchIt.includes('case')){
        list = cloneDeep(this.caseSelectedBundles).map((item) => {
          if (this.pickedCaseBundleGroups && this.pickedCaseBundleGroups.id > 0) {
            item.bundlegroup_id = this.pickedCaseBundleGroups.id;
          }
          return item;
        });
      }

      if(this.bundleLevelForBatchIt.includes('unit')){
        list = cloneDeep(this.unitSelectedBundles).map((item) => {
          if (this.pickedUnitBundleGroups && this.pickedUnitBundleGroups.id > 0) {
            item.bundlegroup_id = this.pickedUnitBundleGroups.id;
          }
          return item;
        });
      }

      if(this.bundleLevelForBatchIt.includes('pack')){
        list = cloneDeep(this.packSelectedBundles).map((item) => {
          if (this.pickedPackBundleGroups && this.pickedPackBundleGroups.id > 0) {
            item.bundlegroup_id = this.pickedPackBundleGroups.id;
          }
          return item;
        });
      }
      
      try{
        await this.axios.post("bundles", list);
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-SUCCESSFULLY_PATCHED"),
          });
         
      }catch(err){
        this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-BATCHING_ERROR"),
            type: "error",
          });
          this.isSaving = false;
      }finally{
        this.bundleLevelForBatchIt = [];
        this.closeModal();
      }
    },

    async updateBundles(bundleSelected){
      if(!bundleSelected || !bundleSelected.length) return;
      try{
        await this.axios.post("bundles", bundleSelected);
        return true;
      }catch(err){
        return false;
      }
    },

    recalculate() {
      this.showModal("batchRecalculate");

      this.isSaving = true;
      let ids = [];
      if(this.caseSelectedBundles.length > 0){
        const caseIds  = this.caseSelectedBundles.map((item) => item.id);
        if(caseIds && caseIds.length > 0)
          ids = ids.concat(caseIds);
      }

      if(this.unitSelectedBundles.length > 0){
        const unitIds = this.unitSelectedBundles.map((item) => item.id);
        if(unitIds && unitIds.length > 0){
          ids = ids.concat(unitIds);
        }
      }

      if(this.packSelectedBundles.length > 0){
        const packIds = this.packSelectedBundles.map((item) => item.id);
        if(packIds && packIds.length > 0){
          ids = ids.concat(packIds);
        }
      }

      
        
        const payload = {
        ...this.getFiltersPrepared(),
        ...this.params,
        ids
      };


      this.currentRecalculateStatus = {
        progress: 0,
        total: 0,
        index: 0,
        message: '',
        errorMsg: null,
      };

      this.axios.post('bundles/recalculate', payload).then((res) => {

        let taskLogId = res.data.export_id;

        this.refreshIntervalId = setInterval(() => {
          this.axios.post("bundles/recalculate", { "export_id": taskLogId}).then((resp) => {
            // case error
            if (resp.data.error) {
              this.currentRecalculateStatus.errorMsg = resp.data.error;
              clearInterval(this.refreshIntervalId);
            }
            else {
              this.currentRecalculateStatus = resp.data;
              if (resp.data.progress >= 1) {
                clearInterval(this.refreshIntervalId);
              }
            }
          });
        }, 1000);
      });
    },

    getDataFromApi() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.items = [];

      let payload = {
        filters: {},
        ...this.params,
      };

      // prepare filters for the request
      payload.filters = this.getFiltersPrepared();

      const controller = new AbortController();

      this.axios.post("items/paged", payload, { signal: controller.signal }).then((res) => {

        if (res.data.data[0] != null && res.data.data.length > 0) {
          this.items = res.data.data;
        }

        this.itemsTotal = res.data.totalItems;
        this.pagination.total = res.data.totalItems;
        this.pagination.result = res.data.data.length;
        this.isLoading = false;
        this.$store.commit('RESET_SELECTED_BUNDLES');
      });

      // cancel the request
      controller.abort();
    },

    getPreparedFilterCustomAttribute(filter){
      let filterObj = {};
      if (filter.type == "dropdownSingle" || filter.type == "dropdownMultiple") {
            if (filter.type == "dropdownSingle") {
              if (filter.selection != null) {
                filterObj = {attribute_id: filter.name, value: filter.selection };
              }
            } else {
              if (filter.selection != null && filter.selection.length > 0) {
                filterObj = {attribute_id: filter.name, values: filter.selection };
              }
            }
          } else if (filter.type == "minMax") {
            const selection = cloneDeep(filter.selection);
            if (selection) {
              if (selection.min == "") {
                selection.min = null;
              }else{
                // has value
                if(!this.isMetricUnitSystem && ["width", "height", "length"].includes(filter.name)){
                  selection.min = this.inchToMilimeters(selection.min);
                }
              }
              if (selection.max == "") {
                selection.max = null;
              }else{
                // has value
                if(!this.isMetricUnitSystem && ["width", "height", "length"].includes(filter.name)){
                  selection.max = this.inchToMilimeters(selection.max);
                }
              }
            }

            filterObj = {attribute_id: filter.name, min: selection.min, max: selection.max };
          } else if (filter.type == "datePicker" || filter.type == 'dateRange') {
            filterObj = {attribute_id: filter.name, values: filter.selection };
          }else if (filter.type == "textbox") {
            filterObj = {attribute_id: filter.name, value: filter.selection };
          } else {
            throw new Error(`Custom filter not handle correctly: ${filter.name}`);
          }
          return filterObj;
    },

    getFiltersPrepared() {
      let retFilters = {};

      this.filters.forEach((filter) => {
        if (filter.isActive) {
          if(filter.isCustomAttribute){
            if(!retFilters['customFilters']){
              retFilters['customFilters'] = [];
            }
            retFilters['customFilters'].push(this.getPreparedFilterCustomAttribute(filter));
          }else{
            if (filter.type == "dropdownSingle" || filter.type == "dropdownMultiple") {
            if (filter.type == "dropdownSingle") {
              if (filter.selection != null) {
                retFilters[filter.name] = filter.selection;
              }
            } else {
              if (filter.selection != null && filter.selection.length > 0) {
                retFilters[filter.name] = filter.selection;
              }
            }
          } else if (filter.type == "slipsheet") {
            retFilters[filter.name] = filter.selection;
          } else if (filter.type == "minMax") {
            const selection = cloneDeep(filter.selection);
            if (selection) {
              if (selection.min == "") {
                selection.min = null;
              }else{
                // has value
                if(!this.isMetricUnitSystem && ["width", "height", "length"].includes(filter.name)){
                  selection.min = this.inchToMilimeters(selection.min);
                }
              }
              if (selection.max == "") {
                selection.max = null;
              }else{
                // has value
                if(!this.isMetricUnitSystem && ["width", "height", "length"].includes(filter.name)){
                  selection.max = this.inchToMilimeters(selection.max);
                }
              }
            }

            retFilters[filter.name] = selection;
          } else if (filter.type == "datePicker" || filter.type == 'dateRange') {
            retFilters[filter.name] = filter.selection;
          } else {
            let filterSelected = filter.options.find((o) => o.isSelected == true);

            if (typeof filterSelected != "undefined") {
              retFilters[filter.name] = filterSelected.internalValue;
            } else {
              retFilters[filter.name] = null;
            }
          }
          }
     
        }
      });
      
      return retFilters;
    },

    deleteItem(item) {
      this.$confirm(this.$t("GLOBAL-CONFIRMATION-DELETE-MSG", { NAME: item.name }), {
        title: this.$t("GLOBAL-CONFIRMATION-DELETE-TITLE"),
        buttonTrueText: this.$t("GLOBAL-CONFIRMATION-DELETE-YES"),
        buttonFalseText: this.$t("GLOBAL-CONFIRMATION-DELETE-CANCEL"),
      }).then((res) => {
        if (res) {
          this.axios.delete("items/" + item.id).then((res) => {
            this.initialize();
            this.$store.dispatch("setSnackbar", {
              text: this.$t("GLOBAL-SUCCESSFULLY_DELETED"),
            });
          });
        }
      });
    },

    download() {
      let a = document.createElement("a");
      a.href = this.downloadLink;
      const fileName = this.downloadLink.split("/").pop();
      const fileNameParts = fileName.split('.');
      if(fileNameParts.length <= 1)
      throw Error('Invalid file name');
      a.download = 'Genomix Export_'+moment().format('DD.MM.YY')+'.'+fileNameParts[1];
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    newArticle() {

      if (!this.editedItem.warehouse_id || this.editedItem.warehouse_id == null) {
        this.$store.dispatch("setSnackbar", {
          text: this.$t("ITEM-MSG-MSSING_WAREHOUSE_SELECTION"),
          type: "warning",
        });
        return;
      }

      if(this.$refs.newArticleForm){
        if(!this.$refs.newArticleForm.validate()){
          return;
        }
      }

      this.isSaving = true;

      this.axios
        .post("items", this.editedItem)
        .then((res) => {
          let itemId = res.data.id;
          let promises = [];
          let saveObj = {
            item_id: itemId,
            status: "incomplete",
            level: null,
            name: null,
            gtin: null,
            warehouse_id: this.editedItem.warehouse_id,
          };

          if (this.editedItem.bundles.case.name != null) {
            saveObj.level = "case";
            saveObj.name = this.editedItem.bundles.case.name;
            saveObj.gtin = this.editedItem.bundles.case.gtin;

            promises.push(this.axios.post("bundles", saveObj));
          }

          if (this.editedItem.bundles.pack.name != null) {
            saveObj.level = "pack";
            saveObj.name = this.editedItem.bundles.pack.name;
            saveObj.gtin = this.editedItem.bundles.pack.gtin;

            promises.push(this.axios.post("bundles", saveObj));
          }

          if (this.editedItem.bundles.unit.name != null) {
            saveObj.level = "unit";
            saveObj.name = this.editedItem.bundles.unit.name;
            saveObj.gtin = this.editedItem.bundles.unit.gtin;

            promises.push(this.axios.post("bundles", saveObj));
          }

          Promise.all(promises)
            .then((resp) => {
              this.isSaving = false;
              this.closeModal();
              this.initialize();

              this.$store.dispatch("setSnackbar", {
                text: this.$t("GLOBAL-SUCCESSFULLY_SAVED"),
              });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", {
            text: this.$t("GLOBAL-SAVING_ERROR"),
            type: "error",
          });
          this.isSaving = false;
        });
    },

    showModal(type, id = null) {
      this.dialog.type = type;

      switch (type) {
        case "exportAsHtml":
          this.exportIncludeImages = undefined;
          this.generateDownloadLink("exportAsHtml");
          this.dialog.title = "ARTICLES-EXPORT-TITLE";
          this.dialog.maxSize = "640";
          break;

        case "export":
          this.exportIncludeImages = false;
          this.generateDownloadLink("export");
          this.dialog.title = "ARTICLES-EXPORT-XLS-TITLE";
          this.dialog.maxSize = "640";
          break;


        case "exportWithImages":
          this.exportIncludeImages = true;
          this.dialog.type = 'export';
          this.generateDownloadLink("export");
          this.dialog.title = "ARTICLES-EXPORT-XLS-TITLE";
          this.dialog.maxSize = "640";
          break;

        case "exportAsXml":
          this.exportIncludeImages = false;
          this.generateDownloadLink("exportAsXml");
          this.dialog.title = "ARTICLES-EXPORT-XML-TITLE";
          this.dialog.maxSize = "640";
          break;

        case "exportMenu":
          if(!this.allExportGroups.length){  
            this.fetchExportGroups().then((res) => {
              this.allExportGroups = cloneDeep(res.data).map((el) => {
                let order = 100;
                if(el.group === 'cases') order =0;
                if(el.group === 'packs') order =1;
                if(el.group === 'units') order =2;
                return Object.assign(el, {selected: true, order});
              }).sort((a,b) => {
                return a.order - b.order || String(a.label).localeCompare(String(b.label));
                
              }); 
            });
          }
          this.dialog.title = "ARTICLES-EXPORT-TITLE";
            this.dialog.maxSize = "640";
            if(this.warehouse && Object.entries(this.warehouse).length > 0 && this.warehouseId > 0){
              this.enableXMLExportOption = !!this.warehouse.kisoft;
            }else if(this.warehouses && Array.isArray(this.warehouses) && this.warehouses.length > 0){
              this.enableXMLExportOption = this.warehouses.every((warehouse) => !!warehouse.kisoft);
            }
          break;

        case "import":
          this.dialog.title = "ARTICLES-IMPORT-TITLE";
          this.dialog.maxSize = "640";
          break;

        case "newArticle":
          this.dialog.title = "ARTICLES-NEW_ARTICLE";
          this.dialog.maxSize = "640";

          if(this.$refs.newArticleForm){
            this.$refs.newArticleForm.resetValidation()
          }
          break;

        case "batchProcessing":
          this.dialog.title = "ARTICLES-BATCH_PROCESSING";
          this.dialog.maxSize = "640";
          break;

        case "confirmRecalculate":
          this.dialog.title = "ARTICLES-BATCH_RECALCULATE";
          this.dialog.maxSize = "640";
          break;

        case "batchRecalculate":
          this.dialog.title = "ARTICLES-BATCH_RECALCULATE";
          this.dialog.maxSize = "640";
          break;

        case "duplicates":
          this.dialog.title = "ARTICLES-DUPLICATES";
          this.dialog.maxSize = "840";

          this.duplicatesLoading = true;

          if (this.duplicates == null) {
            this.fetchDuplicates().then((res) => {
              this.duplicates = res.data;
              this.duplicatesLoading = false;
            });
          } else {
            this.duplicatesLoading = false;
          }

          break;

        case "resolveDuplicates":
          this.dialog.title = id;
          this.dialog.maxSize = "840";

          this.duplicateSelected = this.duplicates.duplicates.find((d) => d.name == id);

          // get all attributes, loop through them, and fill them with the id of the first bundle
          this.getBundleAttributes(this.duplicateSelected.bundles).forEach((attr) => {
            this.$set(this.attributesSelection, attr, this.duplicateSelected.bundles[0].id);
          });

          break;

        case "checkBatchAssignBundles":
          this.dialog.title = "ARTICLES-BATCH_PROCESSING-SECURITY_CHECK";
          this.dialog.maxSize = "1024";
          break;

        case "kisoftTelegram":
          this.kisoftTelegram.isLoading = true;

          this.dialog.title = "ARTICLES-KISOFT-TELEGRAM";
          this.dialog.maxSize = "1024";
          this.dialog.refreshOnClose = false;
          
          this.axios.get(this.$config.api + "/items/" + id + "/kisoftTelegram").then((res) => {
            this.kisoftTelegram.data = res.data.telegram;
            this.kisoftTelegram.isLoading = false;
          }).catch(err => {
            this.kisoftTelegram.data = {telegram: 'error'};
            this.kisoftTelegram.isLoading = false;
          });
          break;
      }

      if (type == "newArticle" && this.warehouseId == null && this.warehouses == null) {
      } else {
        this.dialog.show = true;
      }
    },

    generateDownloadLink(exportType) {
      // initially reset the refreshIntervalId
      clearInterval(this.refreshIntervalId);

      // reset the downloadLink
      this.downloadLink = null;

      let exportGroups = [];
      if(this.allExportGroups.length > 0){
        exportGroups = this.allExportGroups.filter((el) => el.selected).map((el) => el.group);
      }
      // get filters for the request
      let payload = {
        ...this.getFiltersPrepared(),
        ...this.params,
        exportGroups
      };

      const queryParams = [];
      if (this.warehouseId != null) {
        queryParams.push(`warehouse_id=${this.warehouseId}`);
      }
      if (this.exportIncludeImages) {
        queryParams.push(`includeImages=1`);
      }

      let url = "items/" + exportType + (queryParams.length > 0 ? `?${queryParams.join("&")}` : "");

      this.currentExportStatus = {
        progress: 0,
        total: 0,
        index: 0,
        errorMsg: null,
      };

      this.axios.post(url, payload).then((res) => {

        let taskLogId = res.data.export_id;

        this.refreshIntervalId = setInterval(() => {
          this.axios.get("items/export?export_id=" + taskLogId).then((resp) => {
            // case error
            if (resp.data.error) {
              this.currentExportStatus.errorMsg = resp.data.error;
              clearInterval(this.refreshIntervalId);
            }
            // case finish
            else if (resp.data.url) {
              this.downloadLink = resp.data.url;
              clearInterval(this.refreshIntervalId);
            }

            // case default
            else {
              this.currentExportStatus = resp.data;
            }
          });
        }, 1000);
      });
    },

    closeModal(refresh = false) {
      clearInterval(this.refreshIntervalId);

      this.dialog.show = false;
      this.dialog.fullscreen = false;
      this.dialog.refreshOnClose = true;

      this.pickedCaseBundleGroups = null;
      this.pickedPackBundleGroups = null;
      if(this.batchConfirmationPayload && Object.entries(this.batchConfirmationPayload).length > 0){
          this.removeFromBatchListPayload(cloneDeep(this.batchConfirmationPayload));
          this.batchConfirmationPayload = null;
        }
      this.pickedUnitBundleGroups = null;
      this.isSaving = false;
      this.exportType = undefined;
      this.exportIncludeImages = undefined;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.duplicateSelected = null;
      });

      this.kisoftTelegram.data = null;

      if (refresh) {
        this.initialize();
      }
    },

    initialize() {
      this.getDataFromApi();
    },

    rowClick(item) {
      this.editItem(item);
    },

    initAttributes(){
      this.axios.get("attributes").then((res) => {
        const items = res.data;
        this.bundleCustomAttributes = cloneDeep(items).filter((el) => el.isBundleAttribute && el.isCustom);
        this.itemCustomAttributes = cloneDeep(items).filter((el) => el.isItemAttribute  && el.isCustom);
      });
    },

    editItem(item) {
      this.$router.push({ name: "item", params: { id: item.item_id } });
    },

    getWarehouses() {
      return this.axios.get("warehouses").then((res) => {
        this.warehouses = res.data;
      });
    },

    formatXml(xml) {
      var formatted = "";
      var reg = /(>)(<)(\/*)/g;
      xml = xml.replace(reg, "$1\r\n$2$3");
      var pad = 0;

      xml.split('\r\n').forEach((node, index) => {
        let indent = 0;
        if (/^<\/\w/.exec(node)) {
          if (pad != 0) {
            pad -= 1;
          }
        } else if (/^<\w[^>]*[^\/]>.*$/.exec(node)) {
          indent = 1;
        }

        let padding = '';
        for (let i = 0; i < pad; i++) {
          padding += '  '; 
        }

        formatted += padding + node + '\r\n';
        pad += indent;
      });
      return formatted;
    },
  },
};
</script>

<style lang="scss">
.filters {
  .filter {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .filter:not(:last-child) {
    margin-right: 6px;
  }
}
thead .v-data-table__progress {
  display: none;
}

td.selected {
  background-color: yellow;
}

.items{
  display: flex;
  flex-direction: column;

  &__top{

  }

  &__loading-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__list{
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0!important;

    & > li{
      flex: 1;
      list-style: none;
      width: 100%;
      display: flex;
    }

    &--no-data{
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      background-color: #fff;
      padding: 1em .5em;
      border: 1px solid #ccc;
      color: #666666 !important;
      font-family: Arial, sans-serif!important;
      font-weight: 400!important;
      font-size: 14px!important;
      line-height: 16.1px!important;
    }
    
  }
}
</style>
